import { createQueryKeys } from '@lukemorales/query-key-factory';
import { userApis } from '../../apis/user/apis';

export const userQueries = createQueryKeys('user', {
  list: (params) => ({
    queryKey: [params.companyId, params.category, params.keyword, params.service],
    queryFn: async () => {
      const response = await userApis.getUsers(params);
      return response.data;
    },
  }),
});
